<template>
        <p class="tyc-span-center">
                <strong>
                        <span class="tyc-main-title-span">Promoci&oacute;n &quot;Promo con
                                Devoluci&oacute;n 2&deg; Cuota y vale S/100&rdquo;
                        </span>
                </strong>
        </p>
        <p class="tyc-p"><span class="tyc-title-span">&nbsp;</span></p>
        <ol>
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Alcance</span></strong>
                        </p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">Ser&aacute; materia de la presente
                        Promoci&oacute;n Comercial el ofrecer descuentos, sorteos y/o vales entre todos los clientes que
                        efect&uacute;en
                        una compra a trav&eacute;s de la p&aacute;gina Web del siguiente producto.&nbsp;</span></p>
        <p class="tyc-p"><span class="tyc-span">Aplica &uacute;nicamente para las
                        personas
                        naturales que adquieran una p&oacute;liza nueva durante las fechas de vigencia establecidas con
                        un plan de S/220
                        a S/700 del siguiente producto:</span></p>
        <ul>
                <li class="tyc-li-disc">
                        <p class="tyc-p"><span class="tyc-span">Rumbo</span></p>
                </li>
        </ul>
        <p class="tyc-p"><span class="tyc-span">Se accede a la promoci&oacute;n de
                        una cuota
                        gratis solo si se adquiere el producto en cuotas mensuales haciendo uso de la p&aacute;gina Web
                        de Interseguro,
                        accediendo directamente o a trav&eacute;s de nuestros anuncios publicitarios y/o agentes. Los
                        participantes
                        deben cumplir con todos los requisitos establecidos en los presentes t&eacute;rminos y
                        condiciones, los cuales
                        declaran haber le&iacute;do, conocer y aceptar en su totalidad.</span><span
                        class="tyc-span"><br></span><span class="tyc-span">&nbsp;Esta
                        promoci&oacute;n no aplica para otros canales de venta (Interbank, Falabella, Financiera Oh), ni
                        es acumulable
                        con otras promociones o descuentos.</span></p>
        <p class="tyc-p"><br></p>
        <ol start="2">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Beneficios
                                                Promocionales</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><u><span class="tyc-span">Del 01/01 al 31/01:</span></u>
        </p>
        <p class="tyc-p"><span class="tyc-span">Un vale AGORA de S/100 para compras
                        o pago
                        de servicios para compras bajo frecuencia mensual, trimestral, semestral y anual. El vale
                        ser&aacute; enviado
                        entre mi&eacute;rcoles 28 y jueves 29 de febrero y solo a aquellos clientes que mantengan la
                        p&oacute;liza
                        activa.</span></p>
        <p class="tyc-p"><span class="tyc-span">Adicionalmente, acceden a la segunda
                        cuota
                        gratis &uacute;nicamente los planes adquiridos bajo frecuencia de pago mensual. Se realiza la
                        devoluci&oacute;n
                        de la cuota entre el mi&eacute;rcoles 28 y jueves 29 de febrero.</span></p>
        <p class="tyc-p"><span class="tyc-span">La devoluci&oacute;n en la cuota se
                        ver&aacute; reflejado en el estado de cuenta del cliente como extorno. La devoluci&oacute;n
                        aplica
                        &uacute;nicamente a p&oacute;lizas que se mantengan vigentes a la fecha del extorno de la cuota.
                        El tiempo de
                        proceso de los extornos depender&aacute; exclusivamente de las entidades emisoras de las
                        tarjetas, por lo que
                        cualquier demora no ser&aacute; imputable a Interseguro. Aplica para compras con tarjeta Visa
                        y/o MasterCard (No
                        aplica para Diners y/o American Express).</span><span class="tyc-span"><br><br></span></p>
        <ol start="3">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Premios
                                                materia de la
                                                promoci&oacute;n</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">Tarjetas virtuales de AGORA, que
                        pueden ser
                        empleadas para los fines establecidos en los presentes t&eacute;rminos y
                        condiciones.</span><span class="tyc-span"><br><br></span></p>
        <ol start="4">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Vigencia
                                                de la
                                                Promoci&oacute;n</span></strong></p>
                </li>
        </ol>
        <p><br></p>
        <ul>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Fecha de Inicio de
                                        la
                                        promoci&oacute;n: 01:00 horas del lunes 01 de enero del 2024.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Fecha de
                                        Finalizaci&oacute;n de la
                                        promoci&oacute;n: 23:59 horas del mi&eacute;rcoles 31 de enero del 2024.</span>
                        </p>
                </li>
        </ul>
        <p class="tyc-p"><span class="tyc-span">&nbsp;</span></p>
        <ol start="5">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Mec&aacute;nica
                                                de la
                                                promoci&oacute;n</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">Para participar en la
                        promoci&oacute;n, el
                        cliente deber&aacute; efectuar una compra de cualquiera del siguiente producto digital, a
                        trav&eacute;s de la
                        p&aacute;gina Web de Interseguro: Rumbo. Aplicable &uacute;nicamente para planes de S/220 a
                        S/700. Se accede a
                        la promoci&oacute;n de una cuota gratis solo si se adquiere el producto en cuotas
                        mensuales.</span><span class="tyc-span"><br><br></span></p>
        <ol start="6">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Requisitos
                                                para participar del
                                                sorteo</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">Para los vales:</span></p>
        <p class="tyc-p"><span class="tyc-span">Aplica &uacute;nicamente para las
                        personas
                        naturales que adquieran una p&oacute;liza nueva durante las fechas de vigencia establecidas para
                        planes de S/220
                        a S/700.</span></p>
        <p class="tyc-p"><span class="tyc-span">Para la devoluci&oacute;n de una
                        cuota:</span></p>
        <p class="tyc-p"><span class="tyc-span">Aplica &uacute;nicamente para las
                        personas
                        naturales que adquieran una p&oacute;liza nueva durante las fechas de vigencia establecidas para
                        planes de S/220
                        a S/700.</span></p>
        <p class="tyc-p"><span class="tyc-span">Se considerar&aacute;n solamente los
                        productos de Rumbo adquiridos a trav&eacute;s de la p&aacute;gina web www.interseguro.pe desde
                        las 01:00 horas
                        del 01/01/2024 hasta las 23:59:59 horas del 31/01/2024. Aplica exclusivamente para personas
                        naturales con
                        documento nacional de identidad (DNI), carnet de extranjer&iacute;a o pasaporte, mayores de 18
                        a&ntilde;os de
                        edad y residentes en Per&uacute;. Los datos ingresados al momento de la contrataci&oacute;n
                        deben ser correctos
                        y veraces, caso contrario no podr&aacute; hacerse acreedor del premio. La p&oacute;liza
                        adquirida deber&aacute;
                        estar vigente a la fecha y hora de realizaci&oacute;n del sorteo y/o entrega de vales y
                        devoluci&oacute;n de la
                        cuota; asimismo se verificar&aacute; que la p&oacute;liza se encuentre vigente a la fecha de
                        entrega del premio
                        o vale.</span></p>
        <p class="tyc-p"><span class="tyc-span"><br></span><span class="tyc-span"><br></span></p>
        <ol start="7">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Restricciones
                                                del
                                                Sorteo</span></strong></p>
                </li>
        </ol>
        <ul>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Esta
                                        promoci&oacute;n no aplica para
                                        otros canales de venta, ni es acumulable con otras promociones</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Todo intento de
                                        fraude o
                                        interferencia con el sistema de registro eliminar&aacute; al participante del
                                        sorteo.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">No participan
                                        colaboradores de
                                        Interseguro Compa&ntilde;&iacute;a de Seguros S.A.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios no son
                                        canjeables por
                                        dinero u otros bienes.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios incluyen
                                        &uacute;nicamente el concepto anunciado.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios no
                                        incluyen traslados u
                                        otro concepto distinto al indicado.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios no
                                        cuentan con
                                        garant&iacute;a extendida e Interseguro no es responsable de sus gastos de
                                        reparaci&oacute;n y
                                        mantenimiento.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios son
                                        personales e
                                        intransferibles.</span></p>
                </li>
        </ul>
        <p class="tyc-p"><span class="tyc-span">&nbsp;</span></p>
        <ol start="8">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Sobre
                                                Consentimiento y la
                                                Protecci&oacute;n de Datos Personales</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">El solo hecho de participar supone
                        el
                        conocimiento y por tanto la total aceptaci&oacute;n de las presentes Bases por parte de los
                        participantes.</span><span class="tyc-span"><br><br></span></p>
        <p class="tyc-p"><span class="tyc-span">La aceptaci&oacute;n del premio
                        supondr&aacute; la expresa autorizaci&oacute;n del ganador a Interseguro Compa&ntilde;&iacute;a
                        de Seguros S.A.
                        para la difusi&oacute;n p&uacute;blica, transmisi&oacute;n, retransmisi&oacute;n,
                        reproducci&oacute;n o
                        publicaci&oacute;n de los datos personales, las filmaciones, fotograf&iacute;as, im&aacute;genes
                        o grabaciones
                        de las im&aacute;genes y voces de los participantes, en todos y cualesquiera medios de
                        comunicaci&oacute;n
                        conocidos o por conocerse (incluyendo, pero sin limitarse, a gr&aacute;ficos, visuales,
                        audiovisuales,
                        televisi&oacute;n por aire, antena, cable o sat&eacute;lite, radio e Internet) con fines
                        comerciales o con
                        cualquier otra finalidad, sin que el participante tenga derecho a reclamo de
                        indemnizaci&oacute;n,
                        contraprestaci&oacute;n o retribuci&oacute;n alguna.</span></p>
        <p class="tyc-p"><span class="tyc-span">La aceptaci&oacute;n del premio
                        supondr&aacute; la confirmaci&oacute;n de que no existen terceros que tengan derechos de
                        exclusividad sobre la
                        exhibici&oacute;n, publicaci&oacute;n, difusi&oacute;n, reproducci&oacute;n o puesta en el
                        comercio de su
                        imagen, voz y datos personales. En caso contrario, el ganador se comprometer&iacute;a a mantener
                        libres de toda
                        responsabilidad a Interseguro Compa&ntilde;&iacute;a de Seguros S.A. respecto de cualquier
                        reclamo que por este
                        motivo pudieran formular terceros.</span></p>
        <p class="tyc-p"><span class="tyc-span">Interseguro Compa&ntilde;&iacute;a
                        de
                        Seguros S.A. garantiza la seguridad y confidencialidad en el tratamiento de los datos de
                        car&aacute;cter
                        personal facilitados por los usuarios, de conformidad con los dispuesto en la Ley N&deg; 29733,
                        Ley de
                        Protecci&oacute;n de Datos Personales y/o sus normas reglamentarias, complementarias,
                        modificatorias,
                        sustitutorias y dem&aacute;s disposiciones aplicables (en adelante, &ldquo;la
                        Ley&rdquo;).</span></p>
        <p class="tyc-p"><span class="tyc-span">Toda informaci&oacute;n entregada a
                        Interseguro Compa&ntilde;&iacute;a de Seguros S.A. mediante su sitio web www.interseguro.pe
                        ser&aacute; objeto
                        de tratamiento automatizado e incorporada en una o m&aacute;s bases de datos de las que
                        Interseguro
                        Compa&ntilde;&iacute;a de Seguros S.A. ser&aacute; titular y responsable, conforme a los
                        t&eacute;rminos
                        previstos por la Ley.</span></p>
        <p class="tyc-p"><span class="tyc-span">El usuario otorga
                        autorizaci&oacute;n
                        expresa e inequ&iacute;voca a Interseguro Compa&ntilde;&iacute;a de Seguros S.A. para realizar
                        tratamiento y
                        hacer uso de la informaci&oacute;n personal que &eacute;ste proporcione a Interseguro
                        Compa&ntilde;&iacute;a de
                        Seguros S.A. cuando acceda al sitio web www.interseguro.pe, participe en promociones
                        comerciales, env&iacute;e
                        consultas o comunique incidencias, y en general cualquier interacci&oacute;n web, adem&aacute;s
                        de la
                        informaci&oacute;n que se derive del uso de productos y/o servicios que pudiera tener
                        contratados con
                        Interseguro Compa&ntilde;&iacute;a de Seguros y de cualquier informaci&oacute;n p&uacute;blica o
                        que pudiera
                        recoger a trav&eacute;s de fuentes de acceso p&uacute;blico, incluyendo aquellos a los que
                        Interseguro
                        Compa&ntilde;&iacute;a de Seguros S.A. tenga acceso como consecuencia de su navegaci&oacute;n
                        por esta
                        p&aacute;gina web (en adelante, la &ldquo;Informaci&oacute;n&rdquo;) para las finalidades de
                        env&iacute;o de
                        comunicaciones comerciales, comercializaci&oacute;n de productos y servicios, y del
                        mantenimiento de su
                        relaci&oacute;n contractual con Interseguro Compa&ntilde;&iacute;a. La navegaci&oacute;n en la
                        p&aacute;gina web
                        www.interseguro.pe, la participaci&oacute;n en promociones comerciales, y cualquier otra
                        interacci&oacute;n web
                        implica el consentimiento expreso e inequ&iacute;voco del usuario para la cesi&oacute;n de sus
                        datos personales
                        a Interseguro Compa&ntilde;&iacute;a de Seguros S.A. El usuario reconoce y acepta que
                        Interseguro
                        Compa&ntilde;&iacute;a de Seguros S.A. podr&aacute; ceder sus datos personales a cualquier
                        tercero, siempre que
                        sea necesaria su participaci&oacute;n para cumplir con la prestaci&oacute;n de servicios y
                        comercializaci&oacute;n de productos y servicios. Interseguro Compa&ntilde;&iacute;a de Seguros
                        S.A.
                        podr&aacute; ceder, en su caso, la Informaci&oacute;n a sus empresas subsidiarias, filiales,
                        asociadas,
                        afiliadas o miembros del grupo econ&oacute;mico al cual pertenece y/o terceros con los que
                        &eacute;stas
                        mantengan una relaci&oacute;n contractual, supuesto en el cual sus datos ser&aacute;n
                        almacenados en los
                        sistemas inform&aacute;ticos de cualquiera de ellos. En todo caso, Interseguro
                        Compa&ntilde;&iacute;a de Seguros
                        S.A. garantiza el mantenimiento de la confidencialidad y el tratamiento seguro de la
                        Informaci&oacute;n en estos
                        casos. El uso de la Informaci&oacute;n por las empresas antes indicadas se circunscribir&aacute;
                        a los fines
                        contenidos en este documento.</span><span class="tyc-span"><br><br></span>
        </p>
        <p class="tyc-p"><span class="tyc-span">La pol&iacute;tica de privacidad de
                        Interseguro Compa&ntilde;&iacute;a de Seguros S.A. le asegura al usuario el ejercicio de los
                        derechos de
                        informaci&oacute;n, acceso, actualizaci&oacute;n, inclusi&oacute;n, rectificaci&oacute;n,
                        supresi&oacute;n o
                        cancelaci&oacute;n, oposici&oacute;n y revocaci&oacute;n del consentimiento, en los
                        t&eacute;rminos establecidos
                        en la Ley. En cualquier momento, el usuario tendr&aacute; el derecho a solicitar a Interseguro
                        Compa&ntilde;&iacute;a de Seguros S.A. el ejercicio de los derechos que le confiere la Ley,
                        as&iacute; como la
                        revocaci&oacute;n de su consentimiento seg&uacute;n lo previsto en la Ley. Interseguro
                        Compa&ntilde;&iacute;a de
                        Seguros S.A. garantiza la confidencialidad en el tratamiento de los datos de car&aacute;cter
                        personal,
                        as&iacute; como haber adoptado los niveles de seguridad de protecci&oacute;n de los datos
                        personales, instalado
                        todos los medios y adoptado todas las medidas t&eacute;cnicas, organizativas y legales a su
                        alcance que
                        garanticen la seguridad y eviten la alteraci&oacute;n, p&eacute;rdida, tratamiento o acceso no
                        autorizado a los
                        datos personales. Nada de lo incluido aqu&iacute; se interpretar&aacute; como l&iacute;mite o
                        reducci&oacute;n
                        de las responsabilidades y las obligaciones Interseguro Compa&ntilde;&iacute;a de Seguros S.A.
                        hacia sus
                        clientes.</span></p>
        <br><br>
        <p class="tyc-span-center"><span style="font-size:26pt;">&nbsp;</span>
                <strong><span class="tyc-main-title-span">Promoci&oacute;n
                                &quot;Promo con Devoluci&oacute;n
                                2&deg; Cuota y vale
                                S/50&rdquo;</span>
                </strong>
        </p>
        <p class="tyc-p"><span class="tyc-title-span">&nbsp;</span></p>
        <ol>
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Alcance</span></strong>
                        </p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">Ser&aacute; materia de la presente
                        Promoci&oacute;n Comercial el ofrecer descuentos, sorteos y/o vales entre todos los clientes que
                        efect&uacute;en
                        una compra a trav&eacute;s de la p&aacute;gina Web del siguiente producto.&nbsp;</span></p>
        <p class="tyc-p"><span class="tyc-span">Aplica &uacute;nicamente para las
                        personas
                        naturales que adquieran una p&oacute;liza nueva durante las fechas de vigencia establecidas con
                        un plan de S/160
                        a S/200 del siguiente producto:</span></p>
        <ul>
                <li class="tyc-li-disc">
                        <p class="tyc-p"><span class="tyc-span">Rumbo</span></p>
                </li>
        </ul>
        <p class="tyc-p"><span class="tyc-span">Se accede a la promoci&oacute;n de
                        una cuota
                        gratis solo si se adquiere el producto en cuotas mensuales haciendo uso de la p&aacute;gina Web
                        de Interseguro,
                        accediendo directamente o a trav&eacute;s de nuestros anuncios publicitarios y/o agentes. Los
                        participantes
                        deben cumplir con todos los requisitos establecidos en los presentes t&eacute;rminos y
                        condiciones, los cuales
                        declaran haber le&iacute;do, conocer y aceptar en su totalidad.</span><span
                        class="tyc-span"><br></span><span class="tyc-span">&nbsp;Esta
                        promoci&oacute;n no aplica para otros canales de venta (Interbank, Falabella, Financiera Oh), ni
                        es acumulable
                        con otras promociones o descuentos.</span></p>
        <p class="tyc-p"><br></p>
        <ol start="2">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Beneficios
                                                Promocionales</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><u><span class="tyc-span">Del 01/01 al 31/01:</span></u>
        </p>
        <p class="tyc-p"><span class="tyc-span">Un vale AGORA de S/50 para compras o
                        pago de
                        servicios para compras bajo frecuencia mensual, trimestral, semestral y anual. El vale
                        ser&aacute; enviado entre
                        mi&eacute;rcoles 28 y jueves 29 de febrero y solo a aquellos clientes que mantengan la
                        p&oacute;liza
                        activa.</span></p>
        <p class="tyc-p"><span class="tyc-span">Adicionalmente, acceden a la segunda
                        cuota
                        gratis &uacute;nicamente los planes adquiridos bajo frecuencia de pago mensual. Se realiza la
                        devoluci&oacute;n
                        de la cuota entre el mi&eacute;rcoles 28 y jueves 29 de febrero.</span></p>
        <p class="tyc-p"><span class="tyc-span">La devoluci&oacute;n en la cuota se
                        ver&aacute; reflejado en el estado de cuenta del cliente como extorno. La devoluci&oacute;n
                        aplica
                        &uacute;nicamente a p&oacute;lizas que se mantengan vigentes a la fecha del extorno de la cuota.
                        El tiempo de
                        proceso de los extornos depender&aacute; exclusivamente de las entidades emisoras de las
                        tarjetas, por lo que
                        cualquier demora no ser&aacute; imputable a Interseguro. Aplica para compras con tarjeta Visa
                        y/o MasterCard (No
                        aplica para Diners y/o American Express).</span><span class="tyc-span"><br><br></span></p>
        <ol start="3">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Premios
                                                materia de la
                                                promoci&oacute;n</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">Tarjetas virtuales de AGORA, que
                        pueden ser
                        empleadas para los fines establecidos en los presentes t&eacute;rminos y
                        condiciones.</span><span class="tyc-span"><br><br></span></p>
        <ol start="4">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Vigencia
                                                de la
                                                Promoci&oacute;n</span></strong></p>
                </li>
        </ol>
        <p><br></p>
        <ul>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Fecha de Inicio de
                                        la
                                        promoci&oacute;n: 01:00 horas del lunes 01 de enero del 2024.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Fecha de
                                        Finalizaci&oacute;n de la
                                        promoci&oacute;n: 23:59 horas del mi&eacute;rcoles 31 de enero del 2024.</span>
                        </p>
                </li>
        </ul>
        <p class="tyc-p"><span class="tyc-span">&nbsp;</span></p>
        <ol start="5">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Mec&aacute;nica
                                                de la
                                                promoci&oacute;n</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">Para participar en la
                        promoci&oacute;n, el
                        cliente deber&aacute; efectuar una compra de cualquiera del siguiente producto digital, a
                        trav&eacute;s de la
                        p&aacute;gina Web de Interseguro: Rumbo. Aplicable &uacute;nicamente para planes de S/160 a
                        S/200. Se accede a
                        la promoci&oacute;n de una cuota gratis solo si se adquiere el producto en cuotas
                        mensuales.</span><span class="tyc-span"><br><br></span></p>
        <ol start="6">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Requisitos
                                                para participar del
                                                sorteo</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">Para los vales:</span></p>
        <p class="tyc-p"><span class="tyc-span">Aplica &uacute;nicamente para las
                        personas
                        naturales que adquieran una p&oacute;liza nueva durante las fechas de vigencia establecidas para
                        planes de S/160
                        a S/200.</span></p>
        <p class="tyc-p"><span class="tyc-span">Para la devoluci&oacute;n de una
                        cuota:</span></p>
        <p class="tyc-p"><span class="tyc-span">Aplica &uacute;nicamente para las
                        personas
                        naturales que adquieran una p&oacute;liza nueva durante las fechas de vigencia establecidas para
                        planes de S/160
                        a S/200.</span></p>
        <p class="tyc-p"><span class="tyc-span">Se considerar&aacute;n solamente los
                        productos de Rumba adquiridos a trav&eacute;s de la p&aacute;gina web www.interseguro.pe desde
                        las 01:00 horas
                        del 01/01/2024 hasta las 23:59:59 horas del 31/01/2024. Aplica exclusivamente para personas
                        naturales con
                        documento nacional de identidad (DNI), carnet de extranjer&iacute;a o pasaporte, mayores de 18
                        a&ntilde;os de
                        edad y residentes en Per&uacute;. Los datos ingresados al momento de la contrataci&oacute;n
                        deben ser correctos
                        y veraces, caso contrario no podr&aacute; hacerse acreedor del premio. La p&oacute;liza
                        adquirida deber&aacute;
                        estar vigente a la fecha y hora de realizaci&oacute;n del sorteo y/o entrega de vales y
                        devoluci&oacute;n de la
                        cuota; asimismo se verificar&aacute; que la p&oacute;liza se encuentre vigente a la fecha de
                        entrega del premio
                        o vale.</span></p>
        <p class="tyc-p"><span class="tyc-span"><br></span><span class="tyc-span"><br></span></p>
        <ol start="7">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Restricciones
                                                del
                                                Sorteo</span></strong></p>
                </li>
        </ol>
        <ul>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Esta
                                        promoci&oacute;n no aplica para
                                        otros canales de venta, ni es acumulable con otras promociones</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Todo intento de
                                        fraude o
                                        interferencia con el sistema de registro eliminar&aacute; al participante del
                                        sorteo.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">No participan
                                        colaboradores de
                                        Interseguro Compa&ntilde;&iacute;a de Seguros S.A.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios no son
                                        canjeables por
                                        dinero u otros bienes.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios incluyen
                                        &uacute;nicamente el concepto anunciado.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios no
                                        incluyen traslados u
                                        otro concepto distinto al indicado.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios no
                                        cuentan con
                                        garant&iacute;a extendida e Interseguro no es responsable de sus gastos de
                                        reparaci&oacute;n y
                                        mantenimiento.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios son
                                        personales e
                                        intransferibles.</span></p>
                </li>
        </ul>
        <p class="tyc-p"><span class="tyc-span">&nbsp;</span></p>
        <ol start="8">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Sobre
                                                Consentimiento y la
                                                Protecci&oacute;n de Datos Personales</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">El solo hecho de participar supone
                        el
                        conocimiento y por tanto la total aceptaci&oacute;n de las presentes Bases por parte de los
                        participantes.</span><span class="tyc-span"><br><br></span></p>
        <p class="tyc-p"><span class="tyc-span">La aceptaci&oacute;n del premio
                        supondr&aacute; la expresa autorizaci&oacute;n del ganador a Interseguro Compa&ntilde;&iacute;a
                        de Seguros S.A.
                        para la difusi&oacute;n p&uacute;blica, transmisi&oacute;n, retransmisi&oacute;n,
                        reproducci&oacute;n o
                        publicaci&oacute;n de los datos personales, las filmaciones, fotograf&iacute;as, im&aacute;genes
                        o grabaciones
                        de las im&aacute;genes y voces de los participantes, en todos y cualesquiera medios de
                        comunicaci&oacute;n
                        conocidos o por conocerse (incluyendo, pero sin limitarse, a gr&aacute;ficos, visuales,
                        audiovisuales,
                        televisi&oacute;n por aire, antena, cable o sat&eacute;lite, radio e Internet) con fines
                        comerciales o con
                        cualquier otra finalidad, sin que el participante tenga derecho a reclamo de
                        indemnizaci&oacute;n,
                        contraprestaci&oacute;n o retribuci&oacute;n alguna.</span></p>
        <p class="tyc-p"><span class="tyc-span">La aceptaci&oacute;n del premio
                        supondr&aacute; la confirmaci&oacute;n de que no existen terceros que tengan derechos de
                        exclusividad sobre la
                        exhibici&oacute;n, publicaci&oacute;n, difusi&oacute;n, reproducci&oacute;n o puesta en el
                        comercio de su
                        imagen, voz y datos personales. En caso contrario, el ganador se comprometer&iacute;a a mantener
                        libres de toda
                        responsabilidad a Interseguro Compa&ntilde;&iacute;a de Seguros S.A. respecto de cualquier
                        reclamo que por este
                        motivo pudieran formular terceros.</span></p>
        <p class="tyc-p"><span class="tyc-span">Interseguro Compa&ntilde;&iacute;a
                        de
                        Seguros S.A. garantiza la seguridad y confidencialidad en el tratamiento de los datos de
                        car&aacute;cter
                        personal facilitados por los usuarios, de conformidad con los dispuesto en la Ley N&deg; 29733,
                        Ley de
                        Protecci&oacute;n de Datos Personales y/o sus normas reglamentarias, complementarias,
                        modificatorias,
                        sustitutorias y dem&aacute;s disposiciones aplicables (en adelante, &ldquo;la
                        Ley&rdquo;).</span></p>
        <p class="tyc-p"><span class="tyc-span">Toda informaci&oacute;n entregada a
                        Interseguro Compa&ntilde;&iacute;a de Seguros S.A. mediante su sitio web www.interseguro.pe
                        ser&aacute; objeto
                        de tratamiento automatizado e incorporada en una o m&aacute;s bases de datos de las que
                        Interseguro
                        Compa&ntilde;&iacute;a de Seguros S.A. ser&aacute; titular y responsable, conforme a los
                        t&eacute;rminos
                        previstos por la Ley.</span></p>
        <p class="tyc-p"><span class="tyc-span">El usuario otorga
                        autorizaci&oacute;n
                        expresa e inequ&iacute;voca a Interseguro Compa&ntilde;&iacute;a de Seguros S.A. para realizar
                        tratamiento y
                        hacer uso de la informaci&oacute;n personal que &eacute;ste proporcione a Interseguro
                        Compa&ntilde;&iacute;a de
                        Seguros S.A. cuando acceda al sitio web www.interseguro.pe, participe en promociones
                        comerciales, env&iacute;e
                        consultas o comunique incidencias, y en general cualquier interacci&oacute;n web, adem&aacute;s
                        de la
                        informaci&oacute;n que se derive del uso de productos y/o servicios que pudiera tener
                        contratados con
                        Interseguro Compa&ntilde;&iacute;a de Seguros y de cualquier informaci&oacute;n p&uacute;blica o
                        que pudiera
                        recoger a trav&eacute;s de fuentes de acceso p&uacute;blico, incluyendo aquellos a los que
                        Interseguro
                        Compa&ntilde;&iacute;a de Seguros S.A. tenga acceso como consecuencia de su navegaci&oacute;n
                        por esta
                        p&aacute;gina web (en adelante, la &ldquo;Informaci&oacute;n&rdquo;) para las finalidades de
                        env&iacute;o de
                        comunicaciones comerciales, comercializaci&oacute;n de productos y servicios, y del
                        mantenimiento de su
                        relaci&oacute;n contractual con Interseguro Compa&ntilde;&iacute;a. La navegaci&oacute;n en la
                        p&aacute;gina web
                        www.interseguro.pe, la participaci&oacute;n en promociones comerciales, y cualquier otra
                        interacci&oacute;n web
                        implica el consentimiento expreso e inequ&iacute;voco del usuario para la cesi&oacute;n de sus
                        datos personales
                        a Interseguro Compa&ntilde;&iacute;a de Seguros S.A. El usuario reconoce y acepta que
                        Interseguro
                        Compa&ntilde;&iacute;a de Seguros S.A. podr&aacute; ceder sus datos personales a cualquier
                        tercero, siempre que
                        sea necesaria su participaci&oacute;n para cumplir con la prestaci&oacute;n de servicios y
                        comercializaci&oacute;n de productos y servicios. Interseguro Compa&ntilde;&iacute;a de Seguros
                        S.A.
                        podr&aacute; ceder, en su caso, la Informaci&oacute;n a sus empresas subsidiarias, filiales,
                        asociadas,
                        afiliadas o miembros del grupo econ&oacute;mico al cual pertenece y/o terceros con los que
                        &eacute;stas
                        mantengan una relaci&oacute;n contractual, supuesto en el cual sus datos ser&aacute;n
                        almacenados en los
                        sistemas inform&aacute;ticos de cualquiera de ellos. En todo caso, Interseguro
                        Compa&ntilde;&iacute;a de Seguros
                        S.A. garantiza el mantenimiento de la confidencialidad y el tratamiento seguro de la
                        Informaci&oacute;n en estos
                        casos. El uso de la Informaci&oacute;n por las empresas antes indicadas se circunscribir&aacute;
                        a los fines
                        contenidos en este documento.</span><span class="tyc-span"><br><br></span>
        </p>
        <p class="tyc-p"><span class="tyc-span">La pol&iacute;tica de privacidad de
                        Interseguro Compa&ntilde;&iacute;a de Seguros S.A. le asegura al usuario el ejercicio de los
                        derechos de
                        informaci&oacute;n, acceso, actualizaci&oacute;n, inclusi&oacute;n, rectificaci&oacute;n,
                        supresi&oacute;n o
                        cancelaci&oacute;n, oposici&oacute;n y revocaci&oacute;n del consentimiento, en los
                        t&eacute;rminos establecidos
                        en la Ley. En cualquier momento, el usuario tendr&aacute; el derecho a solicitar a Interseguro
                        Compa&ntilde;&iacute;a de Seguros S.A. el ejercicio de los derechos que le confiere la Ley,
                        as&iacute; como la
                        revocaci&oacute;n de su consentimiento seg&uacute;n lo previsto en la Ley. Interseguro
                        Compa&ntilde;&iacute;a de
                        Seguros S.A. garantiza la confidencialidad en el tratamiento de los datos de car&aacute;cter
                        personal,
                        as&iacute; como haber adoptado los niveles de seguridad de protecci&oacute;n de los datos
                        personales, instalado
                        todos los medios y adoptado todas las medidas t&eacute;cnicas, organizativas y legales a su
                        alcance que
                        garanticen la seguridad y eviten la alteraci&oacute;n, p&eacute;rdida, tratamiento o acceso no
                        autorizado a los
                        datos personales. Nada de lo incluido aqu&iacute; se interpretar&aacute; como l&iacute;mite o
                        reducci&oacute;n
                        de las responsabilidades y las obligaciones Interseguro Compa&ntilde;&iacute;a de Seguros S.A.
                        hacia sus
                        clientes.</span></p>
        <br><br>
        <p class="tyc-span-center">
                <strong><span class="tyc-main-title-span">Promoci&oacute;n &quot;Promo con
                                Devoluci&oacute;n 2&deg; Cuota y vale S/100&rdquo;</span>
                </strong>
        </p>
        <p class="tyc-p"><span class="tyc-title-span">&nbsp;</span></p>
        <ol>
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Alcance</span></strong>
                        </p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">Ser&aacute; materia de la presente
                        Promoci&oacute;n Comercial el ofrecer descuentos, sorteos y/o vales entre todos los clientes que
                        efect&uacute;en
                        una compra a trav&eacute;s de la p&aacute;gina Web del siguiente producto.&nbsp;</span></p>
        <p class="tyc-p"><span class="tyc-span">Aplica &uacute;nicamente para las
                        personas
                        naturales que adquieran una p&oacute;liza nueva durante las fechas de vigencia establecidas con
                        un plan de S/220
                        a S/700 del siguiente producto:</span></p>
        <ul>
                <li class="tyc-li-disc">
                        <p class="tyc-p"><span class="tyc-span">Rumbo</span></p>
                </li>
        </ul>
        <p class="tyc-p"><span class="tyc-span">Se accede a la promoci&oacute;n de
                        una cuota
                        gratis solo si se adquiere el producto en cuotas mensuales haciendo uso de la p&aacute;gina Web
                        de Interseguro,
                        accediendo directamente o a trav&eacute;s de nuestros anuncios publicitarios y/o agentes. Los
                        participantes
                        deben cumplir con todos los requisitos establecidos en los presentes t&eacute;rminos y
                        condiciones, los cuales
                        declaran haber le&iacute;do, conocer y aceptar en su totalidad.</span><span
                        class="tyc-span"><br></span><span class="tyc-span">&nbsp;Esta
                        promoci&oacute;n no aplica para otros canales de venta (Interbank, Falabella, Financiera Oh), ni
                        es acumulable
                        con otras promociones o descuentos.</span></p>
        <p class="tyc-p"><br></p>
        <ol start="2">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Beneficios
                                                Promocionales</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><u><span class="tyc-span">Del 01/02 al 29/02:</span></u>
        </p>
        <p class="tyc-p"><span class="tyc-span">Un vale AGORA de S/100 para compras
                        o pago
                        de servicios para compras bajo frecuencia mensual, trimestral, semestral y anual. El vale
                        ser&aacute; enviado
                        entre el s&aacute;bado 30 y el domingo 31 de marzo y solo a aquellos clientes que mantengan la
                        p&oacute;liza
                        activa.</span></p>
        <p class="tyc-p"><span class="tyc-span">Adicionalmente, acceden a la segunda
                        cuota
                        gratis &uacute;nicamente los planes adquiridos bajo frecuencia de pago mensual. Se realiza la
                        devoluci&oacute;n
                        de la cuota entre el s&aacute;bado 30 y domingo 31 de marzo.</span></p>
        <p class="tyc-p"><span class="tyc-span">La devoluci&oacute;n en la cuota se
                        ver&aacute; reflejado en el estado de cuenta del cliente como extorno. La devoluci&oacute;n
                        aplica
                        &uacute;nicamente a p&oacute;lizas que se mantengan vigentes a la fecha del extorno de la cuota.
                        El tiempo de
                        proceso de los extornos depender&aacute; exclusivamente de las entidades emisoras de las
                        tarjetas, por lo que
                        cualquier demora no ser&aacute; imputable a Interseguro. Aplica para compras con tarjeta Visa
                        y/o MasterCard (No
                        aplica para Diners y/o American Express).</span><span class="tyc-span"><br><br></span></p>
        <ol start="3">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Premios
                                                materia de la
                                                promoci&oacute;n</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">Tarjetas virtuales de AGORA, que
                        pueden ser
                        empleadas para los fines establecidos en los presentes t&eacute;rminos y
                        condiciones.</span><span class="tyc-span"><br><br></span></p>
        <ol start="4">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Vigencia
                                                de la
                                                Promoci&oacute;n</span></strong></p>
                </li>
        </ol>
        <p><br></p>
        <ul>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Fecha de Inicio de
                                        la
                                        promoci&oacute;n: 01:00 horas del jueves 01 de febrero del 2024.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Fecha de
                                        Finalizaci&oacute;n de la
                                        promoci&oacute;n: 23:59 horas del jueves 29 de febrero del 2024.</span></p>
                </li>
        </ul>
        <p class="tyc-p"><span class="tyc-span">&nbsp;</span></p>
        <ol start="5">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Mec&aacute;nica
                                                de la
                                                promoci&oacute;n</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">Para participar en la
                        promoci&oacute;n, el
                        cliente deber&aacute; efectuar una compra de cualquiera del siguiente producto digital, a
                        trav&eacute;s de la
                        p&aacute;gina Web de Interseguro: Rumbo. Aplicable &uacute;nicamente para planes de S/220 a
                        S/700. Se accede a
                        la promoci&oacute;n de una cuota gratis solo si se adquiere el producto en cuotas
                        mensuales.</span><span class="tyc-span"><br><br></span></p>
        <ol start="6">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Requisitos
                                                para participar del
                                                sorteo</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">Para los vales:</span></p>
        <p class="tyc-p"><span class="tyc-span">Aplica &uacute;nicamente para las
                        personas
                        naturales que adquieran una p&oacute;liza nueva durante las fechas de vigencia establecidas para
                        planes de S/220
                        a S/700.</span></p>
        <p class="tyc-p"><span class="tyc-span">Para la devoluci&oacute;n de una
                        cuota:</span></p>
        <p class="tyc-p"><span class="tyc-span">Aplica &uacute;nicamente para las
                        personas
                        naturales que adquieran una p&oacute;liza nueva durante las fechas de vigencia establecidas para
                        planes de S/220
                        a S/700.</span></p>
        <p class="tyc-p"><span class="tyc-span">Se considerar&aacute;n solamente los
                        productos de Rumba adquiridos a trav&eacute;s de la p&aacute;gina web www.interseguro.pe desde
                        las 01:00 horas
                        del 01/02/2024 hasta las 23:59:59 horas del 29/02/2024. Aplica exclusivamente para personas
                        naturales con
                        documento nacional de identidad (DNI), carnet de extranjer&iacute;a o pasaporte, mayores de 18
                        a&ntilde;os de
                        edad y residentes en Per&uacute;. Los datos ingresados al momento de la contrataci&oacute;n
                        deben ser correctos
                        y veraces, caso contrario no podr&aacute; hacerse acreedor del premio. La p&oacute;liza
                        adquirida deber&aacute;
                        estar vigente a la fecha y hora de realizaci&oacute;n del sorteo y/o entrega de vales y
                        devoluci&oacute;n de la
                        cuota; asimismo se verificar&aacute; que la p&oacute;liza se encuentre vigente a la fecha de
                        entrega del premio
                        o vale.</span></p>
        <p class="tyc-p"><span class="tyc-span"><br></span><span class="tyc-span"><br></span></p>
        <ol start="7">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Restricciones
                                                del
                                                Sorteo</span></strong></p>
                </li>
        </ol>
        <ul>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Esta
                                        promoci&oacute;n no aplica para
                                        otros canales de venta, ni es acumulable con otras promociones</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Todo intento de
                                        fraude o
                                        interferencia con el sistema de registro eliminar&aacute; al participante del
                                        sorteo.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">No participan
                                        colaboradores de
                                        Interseguro Compa&ntilde;&iacute;a de Seguros S.A.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios no son
                                        canjeables por
                                        dinero u otros bienes.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios incluyen
                                        &uacute;nicamente el concepto anunciado.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios no
                                        incluyen traslados u
                                        otro concepto distinto al indicado.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios no
                                        cuentan con
                                        garant&iacute;a extendida e Interseguro no es responsable de sus gastos de
                                        reparaci&oacute;n y
                                        mantenimiento.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios son
                                        personales e
                                        intransferibles.</span></p>
                </li>
        </ul>
        <p class="tyc-p"><span class="tyc-span">&nbsp;</span></p>
        <ol start="8">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Sobre
                                                Consentimiento y la
                                                Protecci&oacute;n de Datos Personales</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">El solo hecho de participar supone
                        el
                        conocimiento y por tanto la total aceptaci&oacute;n de las presentes Bases por parte de los
                        participantes.</span><span class="tyc-span"><br><br></span></p>
        <p class="tyc-p"><span class="tyc-span">La aceptaci&oacute;n del premio
                        supondr&aacute; la expresa autorizaci&oacute;n del ganador a Interseguro Compa&ntilde;&iacute;a
                        de Seguros S.A.
                        para la difusi&oacute;n p&uacute;blica, transmisi&oacute;n, retransmisi&oacute;n,
                        reproducci&oacute;n o
                        publicaci&oacute;n de los datos personales, las filmaciones, fotograf&iacute;as, im&aacute;genes
                        o grabaciones
                        de las im&aacute;genes y voces de los participantes, en todos y cualesquiera medios de
                        comunicaci&oacute;n
                        conocidos o por conocerse (incluyendo, pero sin limitarse, a gr&aacute;ficos, visuales,
                        audiovisuales,
                        televisi&oacute;n por aire, antena, cable o sat&eacute;lite, radio e Internet) con fines
                        comerciales o con
                        cualquier otra finalidad, sin que el participante tenga derecho a reclamo de
                        indemnizaci&oacute;n,
                        contraprestaci&oacute;n o retribuci&oacute;n alguna.</span></p>
        <p class="tyc-p"><span class="tyc-span">La aceptaci&oacute;n del premio
                        supondr&aacute; la confirmaci&oacute;n de que no existen terceros que tengan derechos de
                        exclusividad sobre la
                        exhibici&oacute;n, publicaci&oacute;n, difusi&oacute;n, reproducci&oacute;n o puesta en el
                        comercio de su
                        imagen, voz y datos personales. En caso contrario, el ganador se comprometer&iacute;a a mantener
                        libres de toda
                        responsabilidad a Interseguro Compa&ntilde;&iacute;a de Seguros S.A. respecto de cualquier
                        reclamo que por este
                        motivo pudieran formular terceros.</span></p>
        <p class="tyc-p"><span class="tyc-span">Interseguro Compa&ntilde;&iacute;a
                        de
                        Seguros S.A. garantiza la seguridad y confidencialidad en el tratamiento de los datos de
                        car&aacute;cter
                        personal facilitados por los usuarios, de conformidad con los dispuesto en la Ley N&deg; 29733,
                        Ley de
                        Protecci&oacute;n de Datos Personales y/o sus normas reglamentarias, complementarias,
                        modificatorias,
                        sustitutorias y dem&aacute;s disposiciones aplicables (en adelante, &ldquo;la
                        Ley&rdquo;).</span></p>
        <p class="tyc-p"><span class="tyc-span">Toda informaci&oacute;n entregada a
                        Interseguro Compa&ntilde;&iacute;a de Seguros S.A. mediante su sitio web www.interseguro.pe
                        ser&aacute; objeto
                        de tratamiento automatizado e incorporada en una o m&aacute;s bases de datos de las que
                        Interseguro
                        Compa&ntilde;&iacute;a de Seguros S.A. ser&aacute; titular y responsable, conforme a los
                        t&eacute;rminos
                        previstos por la Ley.</span></p>
        <p class="tyc-p"><span class="tyc-span">El usuario otorga
                        autorizaci&oacute;n
                        expresa e inequ&iacute;voca a Interseguro Compa&ntilde;&iacute;a de Seguros S.A. para realizar
                        tratamiento y
                        hacer uso de la informaci&oacute;n personal que &eacute;ste proporcione a Interseguro
                        Compa&ntilde;&iacute;a de
                        Seguros S.A. cuando acceda al sitio web www.interseguro.pe, participe en promociones
                        comerciales, env&iacute;e
                        consultas o comunique incidencias, y en general cualquier interacci&oacute;n web, adem&aacute;s
                        de la
                        informaci&oacute;n que se derive del uso de productos y/o servicios que pudiera tener
                        contratados con
                        Interseguro Compa&ntilde;&iacute;a de Seguros y de cualquier informaci&oacute;n p&uacute;blica o
                        que pudiera
                        recoger a trav&eacute;s de fuentes de acceso p&uacute;blico, incluyendo aquellos a los que
                        Interseguro
                        Compa&ntilde;&iacute;a de Seguros S.A. tenga acceso como consecuencia de su navegaci&oacute;n
                        por esta
                        p&aacute;gina web (en adelante, la &ldquo;Informaci&oacute;n&rdquo;) para las finalidades de
                        env&iacute;o de
                        comunicaciones comerciales, comercializaci&oacute;n de productos y servicios, y del
                        mantenimiento de su
                        relaci&oacute;n contractual con Interseguro Compa&ntilde;&iacute;a. La navegaci&oacute;n en la
                        p&aacute;gina web
                        www.interseguro.pe, la participaci&oacute;n en promociones comerciales, y cualquier otra
                        interacci&oacute;n web
                        implica el consentimiento expreso e inequ&iacute;voco del usuario para la cesi&oacute;n de sus
                        datos personales
                        a Interseguro Compa&ntilde;&iacute;a de Seguros S.A. El usuario reconoce y acepta que
                        Interseguro
                        Compa&ntilde;&iacute;a de Seguros S.A. podr&aacute; ceder sus datos personales a cualquier
                        tercero, siempre que
                        sea necesaria su participaci&oacute;n para cumplir con la prestaci&oacute;n de servicios y
                        comercializaci&oacute;n de productos y servicios. Interseguro Compa&ntilde;&iacute;a de Seguros
                        S.A.
                        podr&aacute; ceder, en su caso, la Informaci&oacute;n a sus empresas subsidiarias, filiales,
                        asociadas,
                        afiliadas o miembros del grupo econ&oacute;mico al cual pertenece y/o terceros con los que
                        &eacute;stas
                        mantengan una relaci&oacute;n contractual, supuesto en el cual sus datos ser&aacute;n
                        almacenados en los
                        sistemas inform&aacute;ticos de cualquiera de ellos. En todo caso, Interseguro
                        Compa&ntilde;&iacute;a de Seguros
                        S.A. garantiza el mantenimiento de la confidencialidad y el tratamiento seguro de la
                        Informaci&oacute;n en estos
                        casos. El uso de la Informaci&oacute;n por las empresas antes indicadas se circunscribir&aacute;
                        a los fines
                        contenidos en este documento.</span><span class="tyc-span"><br><br></span>
        </p>
        <p class="tyc-p"><span class="tyc-span">La pol&iacute;tica de privacidad de
                        Interseguro Compa&ntilde;&iacute;a de Seguros S.A. le asegura al usuario el ejercicio de los
                        derechos de
                        informaci&oacute;n, acceso, actualizaci&oacute;n, inclusi&oacute;n, rectificaci&oacute;n,
                        supresi&oacute;n o
                        cancelaci&oacute;n, oposici&oacute;n y revocaci&oacute;n del consentimiento, en los
                        t&eacute;rminos establecidos
                        en la Ley. En cualquier momento, el usuario tendr&aacute; el derecho a solicitar a Interseguro
                        Compa&ntilde;&iacute;a de Seguros S.A. el ejercicio de los derechos que le confiere la Ley,
                        as&iacute; como la
                        revocaci&oacute;n de su consentimiento seg&uacute;n lo previsto en la Ley. Interseguro
                        Compa&ntilde;&iacute;a de
                        Seguros S.A. garantiza la confidencialidad en el tratamiento de los datos de car&aacute;cter
                        personal,
                        as&iacute; como haber adoptado los niveles de seguridad de protecci&oacute;n de los datos
                        personales, instalado
                        todos los medios y adoptado todas las medidas t&eacute;cnicas, organizativas y legales a su
                        alcance que
                        garanticen la seguridad y eviten la alteraci&oacute;n, p&eacute;rdida, tratamiento o acceso no
                        autorizado a los
                        datos personales. Nada de lo incluido aqu&iacute; se interpretar&aacute; como l&iacute;mite o
                        reducci&oacute;n
                        de las responsabilidades y las obligaciones Interseguro Compa&ntilde;&iacute;a de Seguros S.A.
                        hacia sus
                        clientes.</span></p>
        <br><br>
        <p class="tyc-span-center"><strong><span class="tyc-main-title-span">
                                Promoci&oacute;n &quot;Promo con
                                Devoluci&oacute;n 2&deg; Cuota y vale S/50&rdquo;</span>
                </strong></p>
        <p class="tyc-p"><span class="tyc-title-span">&nbsp;</span></p>
        <ol>
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Alcance</span></strong>
                        </p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">Ser&aacute; materia de la presente
                        Promoci&oacute;n Comercial el ofrecer descuentos, sorteos y/o vales entre todos los clientes que
                        efect&uacute;en
                        una compra a trav&eacute;s de la p&aacute;gina Web del siguiente producto.&nbsp;</span></p>
        <p class="tyc-p"><span class="tyc-span">Aplica &uacute;nicamente para las
                        personas
                        naturales que adquieran una p&oacute;liza nueva durante las fechas de vigencia establecidas con
                        un plan de S/160
                        a S/200 del siguiente producto:</span></p>
        <ul>
                <li class="tyc-li-disc">
                        <p class="tyc-p"><span class="tyc-span">Rumbo</span></p>
                </li>
        </ul>
        <p class="tyc-p"><span class="tyc-span">Se accede a la promoci&oacute;n de
                        una cuota
                        gratis solo si se adquiere el producto en cuotas mensuales haciendo uso de la p&aacute;gina Web
                        de Interseguro,
                        accediendo directamente o a trav&eacute;s de nuestros anuncios publicitarios y/o agentes. Los
                        participantes
                        deben cumplir con todos los requisitos establecidos en los presentes t&eacute;rminos y
                        condiciones, los cuales
                        declaran haber le&iacute;do, conocer y aceptar en su totalidad.</span><span
                        class="tyc-span"><br></span><span class="tyc-span">&nbsp;Esta
                        promoci&oacute;n no aplica para otros canales de venta (Interbank, Falabella, Financiera Oh), ni
                        es acumulable
                        con otras promociones o descuentos.</span></p>
        <p class="tyc-p"><br></p>
        <ol start="2">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Beneficios
                                                Promocionales</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><u><span class="tyc-span">Del 01/02 al 29/02:</span></u>
        </p>
        <p class="tyc-p"><span class="tyc-span">Un vale AGORA de S/50 para compras o
                        pago de
                        servicios para compras bajo frecuencia mensual, trimestral, semestral y anual. El vale
                        ser&aacute; enviado entre
                        el s&aacute;bado 30 y el domingo 31 de marzo y solo a aquellos clientes que mantengan la
                        p&oacute;liza
                        activa.</span></p>
        <p class="tyc-p"><span class="tyc-span">Adicionalmente, acceden a la segunda
                        cuota
                        gratis &uacute;nicamente los planes adquiridos bajo frecuencia de pago mensual. Se realiza la
                        devoluci&oacute;n
                        de la cuota entre el s&aacute;bado 30 y domingo 31 de marzo.</span></p>
        <p class="tyc-p"><span class="tyc-span">La devoluci&oacute;n en la cuota se
                        ver&aacute; reflejado en el estado de cuenta del cliente como extorno. La devoluci&oacute;n
                        aplica
                        &uacute;nicamente a p&oacute;lizas que se mantengan vigentes a la fecha del extorno de la cuota.
                        El tiempo de
                        proceso de los extornos depender&aacute; exclusivamente de las entidades emisoras de las
                        tarjetas, por lo que
                        cualquier demora no ser&aacute; imputable a Interseguro. Aplica para compras con tarjeta Visa
                        y/o MasterCard (No
                        aplica para Diners y/o American Express).</span><span class="tyc-span"><br><br></span></p>
        <ol start="3">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Premios
                                                materia de la
                                                promoci&oacute;n</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">Tarjetas virtuales de AGORA, que
                        pueden ser
                        empleadas para los fines establecidos en los presentes t&eacute;rminos y
                        condiciones.</span><span class="tyc-span"><br><br></span></p>
        <ol start="4">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Vigencia
                                                de la
                                                Promoci&oacute;n</span></strong></p>
                </li>
        </ol>
        <p><br></p>
        <ul>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Fecha de Inicio de
                                        la
                                        promoci&oacute;n: 01:00 horas del jueves 01 de febrero del 2024.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Fecha de
                                        Finalizaci&oacute;n de la
                                        promoci&oacute;n: 23:59 horas del jueves 29 de febrero del 2024.</span></p>
                </li>
        </ul>
        <p class="tyc-p"><span class="tyc-span">&nbsp;</span></p>
        <ol start="5">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Mec&aacute;nica
                                                de la
                                                promoci&oacute;n</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">Para participar en la
                        promoci&oacute;n, el
                        cliente deber&aacute; efectuar una compra de cualquiera del siguiente producto digital, a
                        trav&eacute;s de la
                        p&aacute;gina Web de Interseguro: Rumbo. Aplicable &uacute;nicamente para planes de S/160 a
                        S/200. Se accede a
                        la promoci&oacute;n de una cuota gratis solo si se adquiere el producto en cuotas
                        mensuales.</span><span class="tyc-span"><br><br></span></p>
        <ol start="6">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Requisitos
                                                para participar del
                                                sorteo</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">Para los vales:</span></p>
        <p class="tyc-p"><span class="tyc-span">Aplica &uacute;nicamente para las
                        personas
                        naturales que adquieran una p&oacute;liza nueva durante las fechas de vigencia establecidas para
                        planes de S/160
                        a S/200.</span></p>
        <p class="tyc-p"><span class="tyc-span">Para la devoluci&oacute;n de una
                        cuota:</span></p>
        <p class="tyc-p"><span class="tyc-span">Aplica &uacute;nicamente para las
                        personas
                        naturales que adquieran una p&oacute;liza nueva durante las fechas de vigencia establecidas para
                        planes de S/160
                        a S/200.</span></p>
        <p class="tyc-p"><span class="tyc-span">Se considerar&aacute;n solamente los
                        productos de Rumba adquiridos a trav&eacute;s de la p&aacute;gina web www.interseguro.pe desde
                        las 01:00 horas
                        del 01/02/2024 hasta las 23:59:59 horas del 29/02/2024. Aplica exclusivamente para personas
                        naturales con
                        documento nacional de identidad (DNI), carnet de extranjer&iacute;a o pasaporte, mayores de 18
                        a&ntilde;os de
                        edad y residentes en Per&uacute;. Los datos ingresados al momento de la contrataci&oacute;n
                        deben ser correctos
                        y veraces, caso contrario no podr&aacute; hacerse acreedor del premio. La p&oacute;liza
                        adquirida deber&aacute;
                        estar vigente a la fecha y hora de realizaci&oacute;n del sorteo y/o entrega de vales y
                        devoluci&oacute;n de la
                        cuota; asimismo se verificar&aacute; que la p&oacute;liza se encuentre vigente a la fecha de
                        entrega del premio
                        o vale.</span></p>
        <p class="tyc-p"><span class="tyc-span"><br></span><span class="tyc-span"><br></span></p>
        <ol start="7">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Restricciones
                                                del
                                                Sorteo</span></strong></p>
                </li>
        </ol>
        <ul>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Esta
                                        promoci&oacute;n no aplica para
                                        otros canales de venta, ni es acumulable con otras promociones</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Todo intento de
                                        fraude o
                                        interferencia con el sistema de registro eliminar&aacute; al participante del
                                        sorteo.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">No participan
                                        colaboradores de
                                        Interseguro Compa&ntilde;&iacute;a de Seguros S.A.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios no son
                                        canjeables por
                                        dinero u otros bienes.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios incluyen
                                        &uacute;nicamente el concepto anunciado.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios no
                                        incluyen traslados u
                                        otro concepto distinto al indicado.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios no
                                        cuentan con
                                        garant&iacute;a extendida e Interseguro no es responsable de sus gastos de
                                        reparaci&oacute;n y
                                        mantenimiento.</span></p>
                </li>
                <li class="tyc-li">
                        <p class="tyc-p"><span class="tyc-span">Los premios son
                                        personales e
                                        intransferibles.</span></p>
                </li>
        </ul>
        <p class="tyc-p"><span class="tyc-span">&nbsp;</span></p>
        <ol start="8">
                <li class="tyc-li-decimal">
                        <p class="tyc-p"><strong><span class="tyc-subtitle-span">Sobre
                                                Consentimiento y la
                                                Protecci&oacute;n de Datos Personales</span></strong></p>
                </li>
        </ol>
        <p class="tyc-p"><span class="tyc-span">El solo hecho de participar supone
                        el
                        conocimiento y por tanto la total aceptaci&oacute;n de las presentes Bases por parte de los
                        participantes.</span><span class="tyc-span"><br><br></span></p>
        <p class="tyc-p"><span class="tyc-span">La aceptaci&oacute;n del premio
                        supondr&aacute; la expresa autorizaci&oacute;n del ganador a Interseguro Compa&ntilde;&iacute;a
                        de Seguros S.A.
                        para la difusi&oacute;n p&uacute;blica, transmisi&oacute;n, retransmisi&oacute;n,
                        reproducci&oacute;n o
                        publicaci&oacute;n de los datos personales, las filmaciones, fotograf&iacute;as, im&aacute;genes
                        o grabaciones
                        de las im&aacute;genes y voces de los participantes, en todos y cualesquiera medios de
                        comunicaci&oacute;n
                        conocidos o por conocerse (incluyendo, pero sin limitarse, a gr&aacute;ficos, visuales,
                        audiovisuales,
                        televisi&oacute;n por aire, antena, cable o sat&eacute;lite, radio e Internet) con fines
                        comerciales o con
                        cualquier otra finalidad, sin que el participante tenga derecho a reclamo de
                        indemnizaci&oacute;n,
                        contraprestaci&oacute;n o retribuci&oacute;n alguna.</span></p>
        <p class="tyc-p"><span class="tyc-span">La aceptaci&oacute;n del premio
                        supondr&aacute; la confirmaci&oacute;n de que no existen terceros que tengan derechos de
                        exclusividad sobre la
                        exhibici&oacute;n, publicaci&oacute;n, difusi&oacute;n, reproducci&oacute;n o puesta en el
                        comercio de su
                        imagen, voz y datos personales. En caso contrario, el ganador se comprometer&iacute;a a mantener
                        libres de toda
                        responsabilidad a Interseguro Compa&ntilde;&iacute;a de Seguros S.A. respecto de cualquier
                        reclamo que por este
                        motivo pudieran formular terceros.</span></p>
        <p class="tyc-p"><span class="tyc-span">Interseguro Compa&ntilde;&iacute;a
                        de
                        Seguros S.A. garantiza la seguridad y confidencialidad en el tratamiento de los datos de
                        car&aacute;cter
                        personal facilitados por los usuarios, de conformidad con los dispuesto en la Ley N&deg; 29733,
                        Ley de
                        Protecci&oacute;n de Datos Personales y/o sus normas reglamentarias, complementarias,
                        modificatorias,
                        sustitutorias y dem&aacute;s disposiciones aplicables (en adelante, &ldquo;la
                        Ley&rdquo;).</span></p>
        <p class="tyc-p"><span class="tyc-span">Toda informaci&oacute;n entregada a
                        Interseguro Compa&ntilde;&iacute;a de Seguros S.A. mediante su sitio web www.interseguro.pe
                        ser&aacute; objeto
                        de tratamiento automatizado e incorporada en una o m&aacute;s bases de datos de las que
                        Interseguro
                        Compa&ntilde;&iacute;a de Seguros S.A. ser&aacute; titular y responsable, conforme a los
                        t&eacute;rminos
                        previstos por la Ley.</span></p>
        <p class="tyc-p"><span class="tyc-span">El usuario otorga
                        autorizaci&oacute;n
                        expresa e inequ&iacute;voca a Interseguro Compa&ntilde;&iacute;a de Seguros S.A. para realizar
                        tratamiento y
                        hacer uso de la informaci&oacute;n personal que &eacute;ste proporcione a Interseguro
                        Compa&ntilde;&iacute;a de
                        Seguros S.A. cuando acceda al sitio web www.interseguro.pe, participe en promociones
                        comerciales, env&iacute;e
                        consultas o comunique incidencias, y en general cualquier interacci&oacute;n web, adem&aacute;s
                        de la
                        informaci&oacute;n que se derive del uso de productos y/o servicios que pudiera tener
                        contratados con
                        Interseguro Compa&ntilde;&iacute;a de Seguros y de cualquier informaci&oacute;n p&uacute;blica o
                        que pudiera
                        recoger a trav&eacute;s de fuentes de acceso p&uacute;blico, incluyendo aquellos a los que
                        Interseguro
                        Compa&ntilde;&iacute;a de Seguros S.A. tenga acceso como consecuencia de su navegaci&oacute;n
                        por esta
                        p&aacute;gina web (en adelante, la &ldquo;Informaci&oacute;n&rdquo;) para las finalidades de
                        env&iacute;o de
                        comunicaciones comerciales, comercializaci&oacute;n de productos y servicios, y del
                        mantenimiento de su
                        relaci&oacute;n contractual con Interseguro Compa&ntilde;&iacute;a. La navegaci&oacute;n en la
                        p&aacute;gina web
                        www.interseguro.pe, la participaci&oacute;n en promociones comerciales, y cualquier otra
                        interacci&oacute;n web
                        implica el consentimiento expreso e inequ&iacute;voco del usuario para la cesi&oacute;n de sus
                        datos personales
                        a Interseguro Compa&ntilde;&iacute;a de Seguros S.A. El usuario reconoce y acepta que
                        Interseguro
                        Compa&ntilde;&iacute;a de Seguros S.A. podr&aacute; ceder sus datos personales a cualquier
                        tercero, siempre que
                        sea necesaria su participaci&oacute;n para cumplir con la prestaci&oacute;n de servicios y
                        comercializaci&oacute;n de productos y servicios. Interseguro Compa&ntilde;&iacute;a de Seguros
                        S.A.
                        podr&aacute; ceder, en su caso, la Informaci&oacute;n a sus empresas subsidiarias, filiales,
                        asociadas,
                        afiliadas o miembros del grupo econ&oacute;mico al cual pertenece y/o terceros con los que
                        &eacute;stas
                        mantengan una relaci&oacute;n contractual, supuesto en el cual sus datos ser&aacute;n
                        almacenados en los
                        sistemas inform&aacute;ticos de cualquiera de ellos. En todo caso, Interseguro
                        Compa&ntilde;&iacute;a de Seguros
                        S.A. garantiza el mantenimiento de la confidencialidad y el tratamiento seguro de la
                        Informaci&oacute;n en estos
                        casos. El uso de la Informaci&oacute;n por las empresas antes indicadas se circunscribir&aacute;
                        a los fines
                        contenidos en este documento.</span><span class="tyc-span"><br><br></span>
        </p>
        <p class="tyc-p"><span class="tyc-span">La pol&iacute;tica de privacidad de
                        Interseguro Compa&ntilde;&iacute;a de Seguros S.A. le asegura al usuario el ejercicio de los
                        derechos de
                        informaci&oacute;n, acceso, actualizaci&oacute;n, inclusi&oacute;n, rectificaci&oacute;n,
                        supresi&oacute;n o
                        cancelaci&oacute;n, oposici&oacute;n y revocaci&oacute;n del consentimiento, en los
                        t&eacute;rminos establecidos
                        en la Ley. En cualquier momento, el usuario tendr&aacute; el derecho a solicitar a Interseguro
                        Compa&ntilde;&iacute;a de Seguros S.A. el ejercicio de los derechos que le confiere la Ley,
                        as&iacute; como la
                        revocaci&oacute;n de su consentimiento seg&uacute;n lo previsto en la Ley. Interseguro
                        Compa&ntilde;&iacute;a de
                        Seguros S.A. garantiza la confidencialidad en el tratamiento de los datos de car&aacute;cter
                        personal,
                        as&iacute; como haber adoptado los niveles de seguridad de protecci&oacute;n de los datos
                        personales, instalado
                        todos los medios y adoptado todas las medidas t&eacute;cnicas, organizativas y legales a su
                        alcance que
                        garanticen la seguridad y eviten la alteraci&oacute;n, p&eacute;rdida, tratamiento o acceso no
                        autorizado a los
                        datos personales. Nada de lo incluido aqu&iacute; se interpretar&aacute; como l&iacute;mite o
                        reducci&oacute;n
                        de las responsabilidades y las obligaciones Interseguro Compa&ntilde;&iacute;a de Seguros S.A.
                        hacia sus
                        clientes.</span></p>
        <p><br></p>
        <p><br></p>
</template>
<script setup></script>